import React from 'react';
import { connect } from 'react-redux';

import { UserAccountId } from 'api/UserAccount/model/UserAccountId';

import { SignUpForm } from '../SignUpForm/SignUpForm';
import { ThanksForRegistering } from '../ThanksForRegistering/ThanksForRegistering';

import { ISignUpFormState, signUpFormFieldName } from '../SignUpForm/reducers';

import { SignUpFormActions, SignUpFormDispatch } from '../SignUpForm/actions';
import { ThanksForRegisteringActions, ThanksForRegisteringDispatch } from '../ThanksForRegistering/actions';
import { IEmbeddedSignUpFormState } from './reducers';

import { AddressFormFieldName } from 'shared/components/AddressForm/AddressForm';
import { IValidationInputData } from 'shared/components/ValidationInput';

import 'shared/css/EmbeddedSignUpForm.scss';

export interface IEmbeddedSignUpFormProps {
    embeddedSignUpFormState : IEmbeddedSignUpFormState;
    additionalFieldsAreShown : boolean;
    additionalRetailerFieldsAreRequired : boolean;
    onSuccessfulSignUp : (userAccountIdentifier : UserAccountId, signUpFormState : ISignUpFormState) => Promise<void>;
}

export interface IBoundEmbeddedSignUpFormProps extends IEmbeddedSignUpFormProps {
    dispatch : ThanksForRegisteringDispatch & SignUpFormDispatch;
}

export class EmbeddedSignUpForm extends React.Component<IBoundEmbeddedSignUpFormProps, object> {

    public render() {
        const {
            dispatch,
            embeddedSignUpFormState,
            additionalFieldsAreShown,
            additionalRetailerFieldsAreRequired,
            onSuccessfulSignUp,
        } = this.props;

        const getRenderedComponent = () : JSX.Element | null => {
            if (embeddedSignUpFormState.signUpForm.hasSuccessfullySubmitted) {
                const onSendEmailAgainClick = () => {
                    dispatch(ThanksForRegisteringActions.onResendEmail(embeddedSignUpFormState.signUpForm.validationInputDataByFieldName.emailAddress.value));
                };
                const onCloseButtonClick = () => {
                    return;
                };

                return (
                    <ThanksForRegistering
                        isEmbeddedInModal={ false }
                        onSendEmailAgainClick={ onSendEmailAgainClick }
                        onCloseButtonClick={ onCloseButtonClick }
                        isResendingEmail={ embeddedSignUpFormState.thanksForRegistering.isResendingEmail }
                        isEmailResent={ embeddedSignUpFormState.thanksForRegistering.isEmailResent }
                    />
                );
            } else {
                const onFormFieldChange = (field : signUpFormFieldName, value : string | boolean) => {
                    return dispatch(SignUpFormActions.onFormFieldChange(field, value));
                };

                const onFormFieldBlur = (field : signUpFormFieldName, value : string | boolean) => {
                    return dispatch(SignUpFormActions.onFormFieldBlur(field, value));
                };

                const setAddressFormField = (fieldName : AddressFormFieldName, validationInputData : IValidationInputData) => {
                    return dispatch(SignUpFormActions.onSetAddressFormField(fieldName, validationInputData));
                };

                const onSubmit = () => {
                    // if needing retailer fields, need to create session
                    dispatch(SignUpFormActions.onSubmit(embeddedSignUpFormState.signUpForm, additionalFieldsAreShown, additionalRetailerFieldsAreRequired, additionalRetailerFieldsAreRequired))
                    .then((userAccountIdentifier : UserAccountId | void) => {
                        if (userAccountIdentifier) {
                            onSuccessfulSignUp(userAccountIdentifier, embeddedSignUpFormState.signUpForm)
                            .then(() => {
                                dispatch(SignUpFormActions.onSetHasSuccessfullySubmitted(true));
                            });
                        }
                    });
                };

                return (
                    <div className="embedded-sign-up-form">
                        <SignUpForm
                            headerTitle={ null }
                            headerMessage={ null }
                            signUpFormState={ embeddedSignUpFormState.signUpForm }
                            onFormFieldChange={ onFormFieldChange }
                            onFormFieldBlur={ onFormFieldBlur }
                            additionalUserFieldsAreShown={ additionalFieldsAreShown }
                            additionalRetailerFieldsAreShown={ additionalFieldsAreShown }
                            additionalRetailerFieldsAreRequired={ additionalRetailerFieldsAreRequired }
                            submitButtonContents="JOIN BEVSPOT"
                            onSubmit={ onSubmit }
                            setAddressFormField={ setAddressFormField }
                        />
                    </div>
                );
            }
        };

        return getRenderedComponent();
    }
}

export interface IConnectedEmbeddedSignUpFormProps {
    additionalFieldsAreShown : boolean;
    additionalRetailerFieldsAreRequired : boolean;
    onSuccessfulSignUp : (userAccountIdentifier : UserAccountId, signUpFormState : ISignUpFormState) => Promise<void>;
}

interface IState {
    embeddedSignUpFormState : IEmbeddedSignUpFormState;
}
const mapStateToProps = (state : IState, ownProps : IConnectedEmbeddedSignUpFormProps) : IEmbeddedSignUpFormProps => {
    return {
        embeddedSignUpFormState : state.embeddedSignUpFormState,
        additionalFieldsAreShown : ownProps.additionalFieldsAreShown,
        additionalRetailerFieldsAreRequired: ownProps.additionalRetailerFieldsAreRequired,
        onSuccessfulSignUp : ownProps.onSuccessfulSignUp,
    };
};

export const ConnectedEmbeddedSignUpForm = connect<IEmbeddedSignUpFormProps, object, IConnectedEmbeddedSignUpFormProps, IState>(mapStateToProps)(EmbeddedSignUpForm);
